
import React, { Component } from "react";
import { Row, Col, Alert, Button, Form, Input } from "antd";

// Redux

import { withRouter, Link } from "react-router-dom";



// import images
import logodark from "../../assets/images/logo-dark.png";

class ForgetPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        // handleValidSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
    }



    render() {
        return (
            <React.Fragment>
                <div>
                    <div className="p-0">
                        <Row className="g-0">
                            <Col xs={24} lg={8}>
                                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                    <div className="w-100">
                                        <Row className="justify-content-center">
                                            <Col lg={18}>
                                                <div>
                                                    <div className="text-center">
                                                        <div>
                                                            <Link to="/" className="logo"><img src={logodark} height="30" alt="logo" /></Link>
                                                        </div>

                                                        <h4 className="font-size-18 mt-4">Reset Password</h4>
                                                        <p className="text-muted">Reset your password to Yds Powai.</p>
                                                    </div>

                                                    <div className="p-2 mt-5">
                                                        {this.props.forgetError && this.props.forgetError ?
                                                            <Alert type="error" message={this.props.forgetError} showIcon className="mb-4" /> : null}
                                                        {
                                                            this.props.message ?
                                                                <Alert type="success" message={this.props.message} showIcon className="mb-4" /> : null
                                                        }
                                                        <Form className="form-horizontal" onFinish={this.handleValidSubmit}>

                                                            <div className="auth-form-group-custom mb-4">
                                                                <i className="ri-mail-line auti-custom-input-icon"></i>
                                                                <label htmlFor="useremail">Email</label>
                                                                <Form.Item
                                                                    name="useremail"
                                                                    initialValue={this.state.username}
                                                                    rules={[
                                                                        { required: true, message: 'Please enter your email' },
                                                                        { type: 'email', message: 'Please enter a valid email' },
                                                                    ]}
                                                                >
                                                                    <Input type="email" className="form-control" id="useremail" placeholder="Enter email" />
                                                                </Form.Item>
                                                            </div>

                                                            <div className="mt-4 text-center">
                                                                <Button type="primary" htmlType="submit" className="w-md waves-effect waves-light">{this.props.loading ? "Loading..." : "Reset"}</Button>
                                                            </div>
                                                        </Form>
                                                    </div>

                                                    <div className="mt-5 text-center">
                                                    <p> © {new Date().getFullYear()}  RadarSoft Technologies.  </p>

                                                       </div>
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={0} lg={16}>
                                <div className="authentication-bg">
                                    <div className="bg-overlay"></div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { message, forgetError, loading } = state.Forget;
    return { message, forgetError, loading };
}

export default withRouter(
   (ForgetPasswordPage)
);
